import * as marked from "marked";
import { PUBLIC_PTC_CHANGELOG } from "../env";
import { version } from "../version";
export function getChanges(since) {
    const rawChangelog = PUBLIC_PTC_CHANGELOG;
    if (!rawChangelog) {
        return "";
    }
    const changes = rawChangelog.substring(rawChangelog.indexOf(`## ${version}`), since ? rawChangelog.indexOf(`## ${since}`) : rawChangelog.length);
    return marked.parse(changes, { async: false });
}
export function getUpdateInfo(since) {
    return {
        version: version,
        changes: getChanges(since),
    };
}
export const changelog = getChanges();
//# sourceMappingURL=changes.util.js.map